import { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';

import { isStandardError } from './api/rest-api-error';

let showUnexpectedErrorModalCallback:
  | ((code: number, message: string) => void)
  | null = null;

let showErrorModalCallback: ((message: string) => void) | null = null;

export const registerUnexpectedErrorModalCallback = (
  callback: (code: number, message: string) => void,
) => {
  showUnexpectedErrorModalCallback = callback;
};

export const registerErrorModalCallback = (
  callback: (message: string) => void,
) => {
  showErrorModalCallback = callback;
};

export const triggerUnexpectedErrorModal = (error: AxiosError) => {
  const code: number = error?.response?.status ?? StatusCodes.BAD_REQUEST;
  const errorData = error.response?.data;
  if (isStandardError(errorData)) {
    const message = errorData.errors.map((err) => err.detail).join('\r\n');
    if (showUnexpectedErrorModalCallback) {
      showUnexpectedErrorModalCallback(code, message);
    }
    return;
  }
  if (showUnexpectedErrorModalCallback) {
    showUnexpectedErrorModalCallback(
      code,
      'Sorry, an unexpected issue occurred.',
    );
  }
};

export const triggerErrorModal = (error: AxiosError) => {
  const errorData = error.response?.data;
  if (isStandardError(errorData)) {
    const message = errorData.errors.map((err) => err.detail).join('\r\n');
    if (showErrorModalCallback) {
      showErrorModalCallback(message);
    }
    return;
  }
  if (showErrorModalCallback) {
    showErrorModalCallback(error.message);
  }
};
